import { useIntl } from '@finn/ui-utils';
import { useContext } from 'react';

import { VehicleContext } from '../../product-cards';
import { useKeyDataItems } from '../hooks/useKeyDataItems';
import { KeyDataList } from './KeyDataList';

export const KeyData = () => {
  const i18n = useIntl();
  const { vehicle } = useContext(VehicleContext);
  const items = useKeyDataItems(vehicle);
  const title = i18n.formatMessage('pdp.keyDataTitle');

  return (
    <div className="scroll-mt-[8em]" id="product_info">
      <div className="container">
        <h2 className="body-16-semibold">{title}</h2>
        <KeyDataList items={items} />
      </div>
    </div>
  );
};
